<template>
    <div class="container">
      <div class="decorate-gradient"></div>
      <div class="decorate-gradient2"></div>
      <img class="circle" :src="require('@/assets/circle.svg')" alt="">
      <img class="miniCircle" :src="require('@/assets/miniCircle.svg')" alt="">
  
      <div class="sub-container">
        <div class="up-container">
          <div class="left-side">
            <img class="logo" :src="require('@/assets/heatingOfLentaLogo.svg')" alt="">
            <div class="title-container">
              <h1 v-if="title != ''">
                {{title}}
              </h1>
              <div  v-else class="sceleton-title">
              </div>
            </div>
            
            <button class="button" v-on:click="clicked = !clicked" >
              <svg class="svg" width="26" height="26" viewBox="0 0 37 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="path-1-inside-1_5068_2980" fill="white">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3H6.58473C6.80382 3 6.99739 3.14264 7.06229 3.3519L8.27005 7.24638H7.42578L10.3256 21.08C10.4834 21.8391 10.9157 22.521 11.5468 23.0063C12.1779 23.4916 12.9676 23.7494 13.7777 23.7346H30.555C31.3651 23.7494 32.1548 23.4916 32.7859 23.0063C33.417 22.521 33.8493 21.8391 34.0071 21.08L36.7688 7.24638H11.411L9.92766 2.46328C9.47339 0.998455 8.11838 0 6.58473 0H1.5ZM18.2001 28.7017C18.2001 30.1775 16.9477 31.3739 15.4028 31.3739C13.8579 31.3739 12.6055 30.1775 12.6055 28.7017C12.6055 27.2259 13.8579 26.0295 15.4028 26.0295C16.9477 26.0295 18.2001 27.2259 18.2001 28.7017ZM32.6864 28.7017C32.6864 30.1775 31.434 31.3739 29.8891 31.3739C28.3442 31.3739 27.0918 30.1775 27.0918 28.7017C27.0918 27.2259 28.3442 26.0295 29.8891 26.0295C31.434 26.0295 32.6864 27.2259 32.6864 28.7017Z"/>
                </mask>
                <path d="M7.06229 3.3519L5.15204 3.94431L5.15204 3.94431L7.06229 3.3519ZM8.27005 7.24638V9.24638H10.9843L10.1803 6.65397L8.27005 7.24638ZM7.42578 7.24638V5.24638H4.96308L5.46832 7.6567L7.42578 7.24638ZM10.3256 21.08L12.2837 20.6728L12.283 20.6696L10.3256 21.08ZM11.5468 23.0063L10.3277 24.5917L10.3277 24.5917L11.5468 23.0063ZM13.7777 23.7346V21.7346H13.7594L13.7411 21.7349L13.7777 23.7346ZM30.555 23.7346L30.5916 21.7349L30.5733 21.7346H30.555V23.7346ZM32.7859 23.0063L34.005 24.5917L34.005 24.5917L32.7859 23.0063ZM34.0071 21.08L35.9653 21.4871L35.9669 21.4793L35.9684 21.4715L34.0071 21.08ZM36.7688 7.24638L38.7301 7.63792L39.2076 5.24638H36.7688V7.24638ZM11.411 7.24638L9.50076 7.83879L9.93728 9.24638H11.411V7.24638ZM9.92766 2.46328L11.8379 1.87087V1.87087L9.92766 2.46328ZM2 1.5C2 1.77614 1.77614 2 1.5 2V-2C-0.432997 -2 -2 -0.432997 -2 1.5H2ZM1.5 1C1.77614 1 2 1.22386 2 1.5H-2C-2 3.433 -0.432997 5 1.5 5V1ZM6.58473 1H1.5V5H6.58473V1ZM8.97254 2.75949C8.64806 1.71318 7.68019 1 6.58473 1V5C5.92745 5 5.34673 4.57209 5.15204 3.94431L8.97254 2.75949ZM10.1803 6.65397L8.97254 2.75949L5.15204 3.94431L6.3598 7.83879L10.1803 6.65397ZM8.27005 5.24638H7.42578V9.24638H8.27005V5.24638ZM5.46832 7.6567L8.36811 21.4903L12.283 20.6696L9.38324 6.83606L5.46832 7.6567ZM8.36745 21.4871C8.62552 22.7283 9.32834 23.8233 10.3277 24.5917L12.766 21.4208C12.5031 21.2187 12.3413 20.9498 12.2837 20.6728L8.36745 21.4871ZM10.3277 24.5917C11.3251 25.3588 12.5595 25.7572 13.8143 25.7342L13.7411 21.7349C13.3758 21.7416 13.0308 21.6244 12.766 21.4208L10.3277 24.5917ZM13.7777 25.7346H30.555V21.7346H13.7777V25.7346ZM30.5184 25.7342C31.7732 25.7572 33.0076 25.3588 34.005 24.5917L31.5667 21.4208C31.3019 21.6244 30.9569 21.7416 30.5916 21.7349L30.5184 25.7342ZM34.005 24.5917C35.0044 23.8233 35.7072 22.7283 35.9653 21.4871L32.049 20.6728C31.9914 20.9498 31.8296 21.2187 31.5667 21.4208L34.005 24.5917ZM35.9684 21.4715L38.7301 7.63792L34.8075 6.85483L32.0458 20.6884L35.9684 21.4715ZM36.7688 5.24638H11.411V9.24638H36.7688V5.24638ZM8.01741 3.05569L9.50076 7.83879L13.3213 6.65397L11.8379 1.87087L8.01741 3.05569ZM6.58473 2C7.242 2 7.82272 2.42791 8.01741 3.05569L11.8379 1.87087C11.1241 -0.430998 8.99475 -2 6.58473 -2V2ZM1.5 2H6.58473V-2H1.5V2ZM15.4028 33.3739C17.9651 33.3739 20.2001 31.3673 20.2001 28.7017H16.2001C16.2001 28.9877 15.9304 29.3739 15.4028 29.3739V33.3739ZM10.6055 28.7017C10.6055 31.3673 12.8405 33.3739 15.4028 33.3739V29.3739C14.8752 29.3739 14.6055 28.9877 14.6055 28.7017H10.6055ZM15.4028 24.0295C12.8405 24.0295 10.6055 26.0361 10.6055 28.7017H14.6055C14.6055 28.4157 14.8752 28.0295 15.4028 28.0295V24.0295ZM20.2001 28.7017C20.2001 26.0361 17.9651 24.0295 15.4028 24.0295V28.0295C15.9304 28.0295 16.2001 28.4157 16.2001 28.7017H20.2001ZM29.8891 33.3739C32.4514 33.3739 34.6864 31.3673 34.6864 28.7017H30.6864C30.6864 28.9877 30.4167 29.3739 29.8891 29.3739V33.3739ZM25.0918 28.7017C25.0918 31.3673 27.3269 33.3739 29.8891 33.3739V29.3739C29.3616 29.3739 29.0918 28.9877 29.0918 28.7017H25.0918ZM29.8891 24.0295C27.3269 24.0295 25.0918 26.0361 25.0918 28.7017H29.0918C29.0918 28.4157 29.3616 28.0295 29.8891 28.0295V24.0295ZM34.6864 28.7017C34.6864 26.0361 32.4514 24.0295 29.8891 24.0295V28.0295C30.4167 28.0295 30.6864 28.4157 30.6864 28.7017H34.6864Z" fill="white" mask="url(#path-1-inside-1_5068_2980)"/>
              </svg>
  
  
              {{ $t('Buttons.buy') }}
            </button>
          </div>
          <img class="devices" :src="require('@/assets/deviceHeatingOfLenta.svg')" alt="">
  
        </div>
        <div class="down-container">
          <div class="video-presentation">
            <h2 class="video-presentation-title">
              видеопрезентация
            </h2>
            <div class="video-container">
              <video class="video" controls autoplay loop muted playsinline>
                  <source  src="https://psv4.userapi.com/s/v1/d/4SyhPnmv2xu0O0bDkkhhE9_6OfGn90n7BH5bs4pH3-3KILGeAwDQ5NnPP98SQul37BxyhChivN1yJbiIy9zKlp3SQAoobTGjGA75sToVdoX7iXR0VtXHyA/bolshoy_vidos_tolko_vebmmp4.webm" type="video/webm">
                  Ваш браузер не поддерживает видео.
              </video> 
            </div>
          </div>
          <div class="description">
            <h2 class="description-title">описание</h2>
            <p class="description-text">
              <b>Система технического осмотра ленточной пожаробезопасности</b> -это программно-технический комплекс, целью которого является определение неисправных роликов для уменьшения износа ленточного полотна и поддержание стабильной работы оборудования на конвейере, путем анализа данных с тепловизора на сервере, установленном в камерах вдоль конвейера.</p>
  
          </div>                                                                                                
        </div>
  
        
      </div>
    </div>
    
  
    <Modal :clicked="clicked" :getClicked="getClickedParent" :title="title"/>
  
  </template> 
  
  <script>
  import CarouselLenta from "@/components/Slider/CarouselLenta.vue";
  import CustomButton from "@/components/ui/CustomButton.vue";
  import Modal from "@/components/ui/Modal.vue"
  
  export default {
    name: "HeaderHeatingOfLenta",
    data() {
      return {
       
        clicked: false,

      }
    },
    components: {CustomButton, CarouselLenta, Modal},
    props: {
      image: {
        
      },
      title: {
        default: ''
      },
      characteristic: {
        default: ""
      },
  
    },
    methods: {
      scrollTo(elementID) {
        let DOMelement = document.getElementById(elementID)
        DOMelement.scrollIntoView({block: "start", behavior: "smooth"});
      },
  
      getClickedParent(clicked) {
        this.clicked=clicked
      }
      
    },
    
  
  }
  </script>
  
  <style scoped>
    .decorate-gradient, .decorate-gradient2 {
      position: absolute;
      width: 1099.3px;
      height: 1098.52px;
  
      z-index: 3;
      background: radial-gradient(29.79% 29.79% at 58.77% 42.1%, rgba(27, 200, 255, 0.2) 0%, rgba(46, 205, 255, 0) 100%), radial-gradient(50% 50.02% at 54.19% 37.74%, rgba(29, 82, 184, 0.4) 0%, rgba(29, 107, 184, 0.0905282) 68.54%, rgba(29, 113, 184, 0) 97.19%);
    }
  
    .decorate-gradient{
      left: -30%;
      top: 20%;
    }
    
    .decorate-gradient2{
      right: 10%;
      top: -10%;
    }
  
    .circle{
      position: absolute;
      left: 0%;
      top: 30%;
      z-index: 3;
  
    }
  
    .miniCircle{
      position: absolute;
      right: 0%;
      top: 0%;
      z-index: 3;
  
    }
  
    .logo{
      min-width: 200px;
      max-width: 100%;
      max-height: 100%;
      -o-object-fit: contain;
      object-fit: contain;
    }
  
  
  
  
    .container {
      width: 100vw;
      display: flex;
      color: white;
      padding-top: 15vh;
        background: linear-gradient(
        0deg,
        rgba(237, 241, 244, 1) 0%,
        rgba(237, 241, 244, 0.9) 10%,
        rgba(237, 241, 244, 0.7) 20%,
        rgba(237, 241, 244, 0.4) 40%,
        rgba(237, 241, 244, 0) 60%
      ),
      linear-gradient(
        0deg,
        rgba(13, 51, 80, 1) 0%,
        rgba(13, 51, 80, 0.8) 15%,
        rgba(13, 51, 80, 0.5) 30%,
        rgba(13, 51, 80, 0.2) 50%,
        rgba(13, 51, 80, 0) 70%
      ),
      #030508;
      z-index: 4;
      justify-content: center;
    }
  
  
    .sub-container{
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 1300px;
      width: 100%;
      z-index: 4;
    }
  
    .up-container{
      display: flex;
      flex-direction: row;
      width: 100%;
      column-gap: 4vh;
    }
  
    .left-side{
      display: flex;
      flex-direction: column;
      align-items: start;
      row-gap: 4vh;
      width: 30%;
  
    }  
  
    h1{
      text-align: start;
      font-size: clamp(30px, 4.8vw, 50px);
    }
  
    .devices{
      /* min-width: 400px; */
      /* width: calc(70% - 10vh); */
      -o-object-fit: contain;
      object-fit: contain;
      margin-left: 0vh;
      height: 100%;
      margin-top: -10vh;
    }
  
    .down-container{
      width: 100%;
      margin-top: -10vh;
    }
    
    .video-presentation{
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      /* height: 50vh; */
      padding-top: 4vh;
    }
  
    .video-presentation-title{
      text-align: center;
      font-size: clamp(30px, 4.8vw, 50px);
      font-family: geometria_extralight;
      text-transform: uppercase;
      padding-bottom: 2vh;
      padding-top: 2vh;
      width: 100%;
    }
  
    .video-container{
      width: 70%;
      min-width: 320px;
      max-width: 1300px;
      display: flex;
      justify-content: center;
      border-radius: 12px;
      box-shadow: 4px 4px 10.4px rgba(0, 0, 0, 0.1), 57px 108px 49px rgba(0, 0, 0, 0.01), 14px 27px 30px rgba(0, 0, 0, 0.03), 0px 0px 0px rgba(0, 0, 0, 0.04), 4px 7px 17px rgba(0, 0, 0, 0.04);
      border-radius: 12px;
  
    }
  
    .video{
      width: 100%;
      /* height: 60vh; */
      border-radius: 12px;
  
    }
  
    .description{
      display: flex;
      flex-direction: column;
      padding-bottom: 4vh;
      width: 100%;
      color: black;
    }
  
    .description-title{
      text-align: center;
      font-size: clamp(30px, 4.8vw, 50px);
      font-family: geometria_extralight;
      text-transform: uppercase;
      padding-bottom: 2vh;
      padding-top: 2vh;
    }
  
    .description-text{
      font-size: clamp(20px, 1vw, 50px);
      
    }
  
    .button {
      width: 32vh;
      min-width: 250px;
      height: 48px;
      border-radius: 15px;
      font-size: clamp(15px, 1.8vh, 50px);
      color: white;
      border: solid 1px white;
      display: flex;
      justify-content: center;
      align-items: center;
      background: none;
      column-gap: 1vh;
      text-transform: uppercase;
      font-family: Geometria_regular;
      cursor: pointer;
      transition: 0.3s;
      position: relative;
    }
  
    .button:hover {
      letter-spacing: 2px;
    }
  
  
  
    @media (max-width: 1300px){
  
      .sub-container{
        width: calc(100% - 8vh);
        padding: 0 4vh;
      }
  
      .devices{
        /* margin-left: 10vh; */

      }
  
      .up-container{
        align-items: center;
      }
  
      .video{
        height: 40vh;
      }
      
    }
  
    @media (max-width: 800px){
  
      .up-container{
        flex-direction: column;
      }
  
      .left-side{
        width: 100%;
        align-items: center;
      }
  
      h1{
        text-align: center;
        width: 100%;
      }
  
      .devices{
        margin-left: 60px;
        padding-top: 4vh;
        max-width: 400px;
        margin-top: 0;
      }
  
  
      .video{
        height: 30vh;
      }
  
      .down-container{
        margin-top: 0vh;
      }
    }
  
  
    @keyframes shine {
      to {
        background-position-x: -200%;
      }
    }
  
    .sceleton-title{
      width: 100%;
      height: 48px;
  
      box-sizing: border-box;
  
      border-radius: 12px;
      
  
      cursor: pointer;
  
      background-position: center;
  
      background: #eee;
      background: var(--sceleton-card);
      border-radius: 5px;
      background-size: 200% 100%;
      animation: 1.5s shine linear infinite;
  
      box-shadow: 1px 2px 12px rgb(0,0,0,0.3);
  
      overflow: hidden;
  
      position: relative;
    }
  
  
  </style>